import { detectDeviceInfo } from 'src/utils/util';

export const getUsageDetailsApiEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/details?${queryParams}`;

export const getValidateMazorCodeEndpoint = (code) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/validatemazorcode?mazorKitCode=${code}`;

function getSapPartnerId(params) {
    if (typeof params === 'string') {
        const queryParams = new URLSearchParams(params);
        return queryParams.get('sapPartnerId') || undefined;
    } else if (typeof params === 'object' && params !== null) {
        return params.sapPartnerId || undefined;
    }
    return undefined;
}
export const getDropdownEnpoint = (
    dropdown,
    params,
    accountPhysicianAPIReplenishment,
    accountPhysicianAPIUsage,
    physicianDropdownZGReportUsageReplenishmentVisibility,
    physicianDropdownZGReportUsageVisibility,
    salesOrg,
    countryISOCode
) => {
    let sapPartnerId = getSapPartnerId(params);
    if (
        sapPartnerId &&
        params &&
        ((physicianDropdownZGReportUsageReplenishmentVisibility === 'VISIBLE' && accountPhysicianAPIReplenishment) ||
            (physicianDropdownZGReportUsageVisibility === 'VISIBLE' && accountPhysicianAPIUsage)) &&
        dropdown === 'physicians'
    ) {
        dropdown = 'ZGphysicians';
    }
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/`;
    switch (dropdown) {
        case 'priceoverridereasons':
            return `${url}priceoverridereasons`;
        case 'procedures':
            return `${url}Surgery/procedure`;
        case 'accounts':
            return `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/aardt/accounts?${params}`;
        case 'districts':
            return `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/aardt/districts?isOrderCreation=true`;
        case 'territories':
            return `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/aardt/territories?isOrderCreation=true&${params}`;
        case 'physicians':
            return `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/order/surgery/physician?${params}`;
        case 'ZGphysicians':
            return `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/aardt/accountPhysician?${params}`;
        case 'accountLookup':
            return `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/aardt/accountLookup?${params}`;
        case 'billToDetails':
            return `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/aardt/billtoaccounts?${params}`;
        //  break;
        default:
            return '';
    }
};

export const createOrUpdateUsageEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage`;

export const getPricesForItemsEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/price?${queryParams}`;

export const getPriveOverrideReasons = () =>
    `/occ/v2/${localStorage.getItem('baseSiteId')}/order/priceoverridereasons`;

export const procedureInfoEndpoint = (data) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/procedureinfo?${data}`;

export const validateProductDetailsEndpoint = () =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/validateproductdetails`;

export const validateRelenEndPoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/products/surgeonValidation`;

export const validateReplenProductsEndpoint = (
    { itemCFNs, soldToAccount, isMastOrder },
    salesOrg
) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/validateproduct?salesOrg=${salesOrg}&orderType=ZLC&productCFN=${itemCFNs}&soldToAccount=${soldToAccount}&isMastOrder=${isMastOrder}`;

export const usageAttachmentUploadEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/attachment`;

export const deleteAttachmentEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/removeAttachment?fileName=${fileName}`;

export const getImagePoPreviewEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/attachment?attachmentName=${fileName}`;

export const cancelUsageEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/cancelUsage`;

export const cancelUsageWithouReasonEndpoint = (myCaseRefId) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/noReportUsage?myCaseRef=${myCaseRefId}`;

//Disparency Endpoint
export const fetchDisparencyEndpoint = (queryParamObj) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/reports/seDiscrepancyUsageReport?descripancyReport=false&isEmail=false&${queryParamObj}`;

export const discrepancyAttachmentUploadEndpoint = () =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/attachmentForSEDiscrepancy`;

export const checkIfOrderLockedEndpoint = (orderDetails) => {
    const { deviceType, browser } = detectDeviceInfo();
    return `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/checkIfOrderLocked?action=${orderDetails.action
        }&browserName=${browser}&deviceName=${deviceType}&editStatus=${orderDetails?.editStatus ? orderDetails.editStatus : 'Initiated'
        }&myCaseRef=${orderDetails.myCaseRefId}&orderType=${orderDetails.orderType
        }`;
};

export const orderUnlockEndpoint = (orderDetails) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/orderUnlock?action=${orderDetails.action
    }&myCaseRef=${orderDetails.myCaseRefId}`;

export const discrepancyUpdateEndpoint = () =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/reports/seDiscrepancyUsageReport`;

export const getOrderStatusDetailsApiEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/orderProcessed?myCaseRef=${queryParams}`;

export const getAccountMessageValidationApi = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}//aardt/validateAccount?${queryParams}`;
